import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";
import { usePriest } from "../lib/auth";
import { perr } from "../lib/api";

export default function PriestLogin() {
  const { login, demoLogin } = usePriest();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const go = async (fn) => {
    setBusy(true);
    try { await fn(); nav("/priest"); }
    catch (e) { toast.error(perr(e, "Sign in failed")); }
    finally { setBusy(false); }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-[#FBF6EF] px-4 font-body">
      <div className="w-full max-w-md rounded-3xl border border-[#Eee3d6] bg-white p-7 shadow-sm">
        <span className="inline-block rounded-full bg-[#F4E4E6] px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-[#8B1A2B]">Priest App</span>
        <h1 className="mt-4 font-heading text-3xl font-bold text-[#2A211C]">Welcome back</h1>
        <p className="mt-1 text-sm text-[#7A6E64]">Join families looking for trusted Purohits.</p>

        <label className="mt-6 block text-xs font-semibold text-[#5C5449]">Email address</label>
        <input data-testid="priest-login-email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com"
          className="mt-1 w-full rounded-xl border border-[#E7DECF] bg-[#FBF7F1] px-3.5 py-3 text-sm outline-none focus:border-[#8B1A2B]" />
        <label className="mt-3 block text-xs font-semibold text-[#5C5449]">Password</label>
        <input data-testid="priest-login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••"
          className="mt-1 w-full rounded-xl border border-[#E7DECF] bg-[#FBF7F1] px-3.5 py-3 text-sm outline-none focus:border-[#8B1A2B]" />

        <button data-testid="priest-login-submit" disabled={busy} onClick={() => go(() => login(email, password))}
          className="mt-5 w-full rounded-xl bg-[#8B1A2B] py-3 text-sm font-semibold text-white hover:bg-[#6F1420] disabled:opacity-60">
          {busy ? "Signing in…" : "Continue with email"}
        </button>

        <button data-testid="priest-demo-login" disabled={busy} onClick={() => go(demoLogin)}
          className="mt-3 flex w-full items-center justify-center gap-2 rounded-xl border border-[#E7C9CD] py-3 text-sm font-semibold text-[#8B1A2B] hover:bg-[#FDF3F4]">
          <Sparkles size={15} /> Enter priest demo
        </button>
        <p className="mt-2 text-center text-xs text-[#A0968A]">Explore the complete priest experience without creating an account.</p>
      </div>
    </div>
  );
}
